import {
  LEADFORM,
  MY_SCAN_LIST,
  SCANNED_IDS,
  SCANNED_USERS,
  SELECTED_SCAN_ITEM,
  SELECTED_SCAN_LINKED_ITEM
} from '../actions';

export const myScanReducer = (state = {}, action) => {
  if (action.type == MY_SCAN_LIST) return action.payload;
  return state;
};

export const selectedScanItemReducer = (state = {}, action) => {
  if (action.type == SELECTED_SCAN_ITEM) return action.payload;
  return state;
};

export const selectedScanLinkedItemReducer = (state = {}, action) => {
  if (action.type == SELECTED_SCAN_LINKED_ITEM) return action.payload;
  return state;
};

// for lead retrival 👇🏻

export const scannedIDsReducer = (state = {}, action) => {
  if (action.type == SCANNED_IDS) return action.payload;
  return state;
};

export const leadUserReducer = (state = [], action) => {
  if (action.type == SCANNED_USERS) return action.payload;
  return state;
};

export const exhibitorLeadForm = (state = [], action) => {
  if (action.type == LEADFORM) return action.payload;
  return state;
};
